import { $Elements, Breakpoints, BrowserEvents, Classes, GoogleMapsStyles, TransitionDurations } from './constants';
import { gsap } from 'gsap';
import Swiper from 'swiper';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Sections ----------

		$('.terroirs-section .controls button').each(function() {
			$(this).hover(() => $(this.dataset.layer).addClass(Classes.active), () => $(this.dataset.layer).removeClass(Classes.active));
		});

		$('.dates-section .carousel').each(function() {

			if(!this.swiper) {

				const pagination = $(this).find('.swiper-pagination');
				const slides = $(this).find('.swiper-slide');

				const progress = $(`
				<div class="swiper-pagination-progressbar">
					<span class="swiper-pagination-progressbar-fill" style="transform: scale(${1 / (slides.length + 1)}, 1);"></span>
				</div>
				`);
				pagination.append(progress);

				const bullets = $(`<div class="pagination-bullets"></div>`);
				slides.each((i, slide) => bullets.append(`<span class="pagination-bullet${(i === 0) ? ' active visible' : ''}">${$(slide).find('.date').text()}</span>`));

				pagination.append(bullets);

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					observer: true,
					effect: 'fade',
					allowTouchMove: false,
					fadeEffect: {
						crossFade: true
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
					on: {
						slideChange: () => {

							const activeIndex = swiper.realIndex + 1;
							const total = slides.length + 1;

							pagination.find('.swiper-pagination-progressbar-fill').css('transform', 'scale(' + (activeIndex / total) + ', 1)');
							pagination.find('.pagination-bullet').removeClass('active visible');

							slides.each((i, slide) => {

								if(i < swiper.realIndex) {
									pagination.find('.pagination-bullet:nth-child(' + (i + 1) + ')').addClass('active');
								}

								if(i === swiper.realIndex) {
									pagination.find('.pagination-bullet:nth-child(' + activeIndex + ')').addClass('active visible');
								}
							});
						}
					}
				});
			}
		});

		$('.hover-text-image-section, .dates-section').each(function() {

			const images = $(this).find('.columns-section-content .hover-image');

			$(this).find('.text strong').each((i, strong) => {

				const activeImage = images.filter('[data-item="' + strong.dataset.item + '"]');

				let pos = { x: 0, y: 0 };
				let mouse = { x: pos.x, y: pos.y };
				let speed = 0.05;

				activeImage.each((i, el) => {
					const xSet = gsap.quickSetter(el, "x", "px");
					const ySet = gsap.quickSetter(el, "y", "px");

					gsap.ticker.add(() => {
						pos.x += (mouse.x - pos.x) * speed;
						pos.y += (mouse.y - pos.y) * speed;
						xSet(pos.x);
						ySet(pos.y);
					});
				});

				$(strong).on('mouseenter touchstart', () => activeImage.addClass(Classes.active));
				$(strong).on('mouseleave touchend touchleave touchcancel', () => activeImage.removeClass(Classes.active));
				$(strong).on('mousemove touchmove', e => {
					mouse.x = -((e.clientX - window.innerWidth / 2) / 15);
					mouse.y = -((e.clientY - window.innerHeight / 2) / 1.5);
				});
			});
		});

		$('.wines-section .carousel').each(function() {

			if(!this.swiper) {

				const pagination = $(this).find('.pagination .current');

				const swiper = new Swiper(this, {
					loop: true,
					slidesPerView: 'auto',
					slideToClickedSlide: true,
					preventInteractionOnTransition: true,
					resistance: false,
					threshold: 10,
					speed: TransitionDurations.default,
					observer: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: 'progressbar',
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
					on: {
						slideChange: () => {

							const active = swiper.slides[swiper.activeIndex];

							pagination.find('.item').removeClass(Classes.active);
							pagination.find('.item[data-carousel-item="' + active.dataset.swiperSlideIndex + '"]').addClass(Classes.active);
						}
					}
				});
			}
		});

		$('.wine-description-section .millesimes-slider').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					slidesPerView: 'auto',
					slideToClickedSlide: true,
					preventInteractionOnTransition: true,
					resistance: false,
					threshold: 10,
					speed: TransitionDurations.default,
					observer: true,
				});
			}
		});

		$('.wine-related-section .carousel').each(function() {

			if(!this.swiper) {
				const pagination = $(this).find('.pagination .current');

				const swiper = new Swiper(this, {
					loop: true,
					slidesPerView: 'auto',
					slideToClickedSlide: true,
					preventInteractionOnTransition: true,
					resistance: false,
					threshold: 10,
					speed: TransitionDurations.default,
					observer: true,
					breakpoints: {
						[Breakpoints.Menu]: {
							loop: false,
							allowTouchMove: false,
						},
					},
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: 'progressbar',
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
					on: {
						slideChange: () => {

							const active = swiper.slides[swiper.activeIndex];

							pagination.find('.item').removeClass(Classes.active);
							pagination.find('.item[data-carousel-item="' + active.dataset.swiperSlideIndex + '"]').addClass(Classes.active);
						}
					}
				});
			}
		});

		$('.map-section .map').each(function() {

			if(this.dataset.lat && this.dataset.lng) {

				const initMap = () => {

					const markerLatLng = new google.maps.LatLng(this.dataset.lat, this.dataset.lng);

					const mapOptions = {
						zoom: 11,
						mapTypeControl: false,
						scrollwheel: false,
						center: markerLatLng,
						styles: GoogleMapsStyles,
					};

					const mapElement = this;

					const map = new google.maps.Map(mapElement, mapOptions);

					let markerOptions = {
						position: markerLatLng,
						map: map,
					};

					if(this.dataset.icon) {

						markerOptions.icon = {
							scaledSize: new google.maps.Size(140, 126),
							url: this.dataset.icon,
						}
					}

					const marker = new google.maps.Marker(markerOptions);
				}

				if(typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
					initMap();
				}
				else {
					$Elements.window.on('load', initMap);
				}
			}
		});

		$('.images-carousel-section .slideshow').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: true,
					slidesPerView: 'auto',
					allowTouchMove: true,
					autoplay: true,
					spaceBetween: 20,
				});
			}
		});
	});

}(jQuery));
